import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AttributeType } from 'src/app/interfaces/product-details';
import { ProductCollectionService } from 'src/app/services/product-collection.service';

@Component({
  selector: 'app-lookup-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class LookupProductsDetailsComponent implements OnInit, OnDestroy {
  categories: string = '';
  clusterEnhanced: boolean = false;

  attributeTypes: { name: AttributeType, title: string }[] = [
    {
      name: 'core',
      title: 'Core Attributes',
    },
    {
      name: 'all',
      title: 'All Attributes',
    },
    {
      name: 'all_with_columns',
      title: 'All Attributes as Columns',
    },
  ];
  selectedAttributeType: AttributeType = 'core';

  additionalAttributes: string = '';

  productCollectionServiceChangedSubscription!: Subscription;

  constructor(
    private productCollectionService: ProductCollectionService,
    public modal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.productCollectionServiceChangedSubscription = this.productCollectionService.watchChanges.subscribe(() => {
      this.categories = this.productCollectionService.categoryIds;
    });
  }

  ngOnDestroy() {
    this.productCollectionServiceChangedSubscription.unsubscribe();
  }

  onChangeCategoies() {
    this.productCollectionService.categoryIds = this.categories;
    this.productCollectionService.changesMade();
  }

  additionalAttributesChanged(attributes: string) {
    this.additionalAttributes = attributes;
  }

  getReportRequestParams(): Record<string, string> {
    const params: Record<string, string> = {
      clusterEnhanced: this.clusterEnhanced.toString()
    };
    let reportParameters: string = 'attributes,' + (this.selectedAttributeType === 'all_with_columns' ? 'all' : this.selectedAttributeType);
    if (this.selectedAttributeType === 'all_with_columns') {
      reportParameters += ',showAllAttr,true';
    } else if (this.selectedAttributeType === 'all' && this.additionalAttributes) {
      reportParameters += ',addnlCore,' + this.additionalAttributes + ',showAllAttr,false';
    }
    params['reportParameters'] = reportParameters;
    return params;
  }

}
